export default "__VITE_ASSET__B2B4IFyD__"